<ng-container *ngIf="!exploring">
  <div class="explore-main">
    <h1 class="hero font-secondary">
      <ng-container *ngIf="where; else marketing_limits">{{where.cityId}}</ng-container>
      <ng-template #marketing_limits>
        <ng-container i18n>Don't put limits on adventure.</ng-container>
      </ng-template>
    </h1>
    <h2 class="hero-sub">
      <ng-container i18n>Earn rewards to pay for your stays, so you can keep your adventure going.</ng-container>
    </h2>

    <div class="explore">
      <button type="button" class="explore-btn left" (click)="explore('where')">
      <!-- <button type="button" class="explore-btn left" (click)="goToMobileApp()"> -->
        <span>
          <ng-container *ngIf="where; else anywhere">{{where.cityId}}</ng-container>
          <ng-template #anywhere>
            <ng-container i18n>Anywhere</ng-container>
          </ng-template>
        </span>
      </button>
      <button type="button" class="explore-btn middle" (click)="explore('when')">
      <!-- <button type="button" class="explore-btn middle" (click)="goToMobileApp()"> -->
        <span>
          <ng-container i18n>Any week</ng-container>
        </span>
      </button>
      <button type="button" class="explore-btn right" (click)="explore('who')">
      <!-- <button type="button" class="explore-btn right" (click)="goToMobileApp()"> -->
        <span>
          <ng-container i18n>By myself</ng-container>
        </span>
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="exploring">
  <div class="explore-main">
    <div class="hero_2">
      <ng-container i18n>Where are you hopping?</ng-container>
    </div>

    <form [formGroup]="searchForm">
      <div class="explore-inputs" (click)="startExploring()">
        <!-- <app-where formControlName="where" id="where" (click)="!where ? activeInput = 'where' : $event.preventDefault()" [active]="activeInput === 'where'"></app-where>
        <app-when formControlName="when" id="when" (click)="activeInput = 'when'" [active]="activeInput === 'when'"></app-when>
        <app-who formControlName="who" id="who" (click)="activeInput = 'who'" [active]="activeInput === 'who'"></app-who> -->
        <app-where formControlName="where" id="where" [active]="activeInput === 'where'"></app-where>
        <app-when formControlName="when" id="when" [active]="activeInput === 'when'"></app-when>
        <app-who formControlName="who" id="who" [active]="activeInput === 'who'"></app-who>
      </div>
    </form>
  </div>
</ng-container>

<!-- <div (click)="startExploring()" *ngIf="!where; else functional"> -->
<div>
  <ng-container *ngIf="isHostel(searchForm.value.where); else pwa">
    <a class="btn btn-theme search-btn btn-large btn-icon" [routerLink]="['/hostels', searchForm.value.where.id]" [queryParams]="searchParams | async">
      <span style="display: flex; align-items: center;">
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Group 136">
            <path id="Vector" d="M9.48927 17.0779C13.9566 17.0779 17.5781 13.4563 17.5781 8.98893C17.5781 4.52153 13.9566 0.899994 9.48927 0.899994C5.0219 0.899994 1.40039 4.52153 1.40039 8.98893C1.40039 13.4563 5.0219 17.0779 9.48927 17.0779Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path id="Vector_2" d="M19.6005 19.1L15.2021 14.7016" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
        </svg>
      </span>
  
      <span>
        <ng-container i18n>Explore</ng-container>
      </span>
    </a>
  </ng-container>
  <!-- <a class="btn btn-theme search-btn btn-large btn-icon" href="https://app.hostelhop.io/#/search/pwa" target="_blank"> -->
    <ng-template #pwa>
      <a class="btn btn-theme search-btn btn-large btn-icon" [href]="pwaUrl | async" target="_blank">
        <span style="display: flex; align-items: center;">
          <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Group 136">
              <path id="Vector" d="M9.48927 17.0779C13.9566 17.0779 17.5781 13.4563 17.5781 8.98893C17.5781 4.52153 13.9566 0.899994 9.48927 0.899994C5.0219 0.899994 1.40039 4.52153 1.40039 8.98893C1.40039 13.4563 5.0219 17.0779 9.48927 17.0779Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path id="Vector_2" d="M19.6005 19.1L15.2021 14.7016" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
          </svg>
        </span>
    
        <span>
          <ng-container i18n>Explore</ng-container>
        </span>
      </a>
    </ng-template>

</div>
<!-- <ng-template #functional>
  <button (click)="exploring ? goToSearchResults() : exploring = true;" class="btn btn-theme search-btn btn-large btn-icon" [disabled]="exploring && !searchForm.valid">
    <svg-icon style="height: 18.2px" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2}" src="/assets/icons/magnifying-glass.svg"></svg-icon>
    <span>
      <ng-container i18n>Explore</ng-container>
    </span>
  </button>
</ng-template> -->
